module.exports = __webpack_public_path__ + "static/media/tram.d35e92e1.svg";